import React, { useEffect } from 'react';
import Icon from '../AppIcon';

/**
 * Non-blocking toast message. Auto-dismisses after duration.
 * @param {{ type: 'success' | 'error' | 'info', message: string } | null} toast
 * @param {number} duration - ms until auto-dismiss (default 4000)
 */
const Toast = ({ toast, onDismiss, duration = 4000 }) => {
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => onDismiss(), duration);
    return () => clearTimeout(t);
  }, [toast, duration, onDismiss]);

  const message =
    toast?.message != null
      ? typeof toast.message === 'string'
        ? toast.message
        : typeof toast.message === 'object' && toast.message !== null && typeof toast.message.message === 'string'
          ? toast.message.message
          : String(toast.message)
      : '';
  if (!message) return null;

  const isSuccess = toast.type === 'success';
  const isError = toast.type === 'error';
  const bg = isError
    ? 'bg-destructive text-destructive-foreground border border-destructive/20'
    : isSuccess
      ? 'bg-primary text-primary-foreground border border-primary/20'
      : 'bg-card text-foreground border border-border';
  const iconName = isError ? 'AlertCircle' : isSuccess ? 'CheckCircle' : 'Info';

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-[7000] flex items-center gap-2.5 px-4 py-3 rounded-xl shadow-elevation-lg backdrop-blur-sm ${bg} text-sm font-medium transition-all duration-200`}
    >
      <Icon name={iconName} size={18} className="flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
};

export default Toast;
